export const toggle = {
  data() {
    return {
      isShowing: false
    }
  },
  methods: {
    toggleShow() {
      this.isShowing = !this.isShowing;
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/mixins/toggle.js